import React from "react";
import { Radio, Row } from "antd";
import Storylist from "../StorylistChildToParent";
import { observer } from "mobx-react";
import Book from "../../models/Book";

const RadioGroup = Radio.Group;
const radioStyle = {
  display: "block",
  height: "30px",
  lineHeight: "30px"
};

let key = 0;

const lists = {
  daughter: {
    dadForParent: [
      ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p"],
      ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p"],
      ["h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "u", "v", "w", "y", "z", "ac", "ad"],
      ["h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "u", "v", "w", "y", "z", "ac", "ad"]
    ],
    dadForParents: [
      ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p"],
      ["h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "u", "v", "w", "y", "z", "ac", "ad"],
      ["q", "r", "s", "u", "v", "w", "y", "z", "ac", "ad"]
    ],
    momForParent: [
      ["ae", "af", "ag", "ah", "ai", "aj", "ak", "al", "am", "an", "ao", "ap", "aq", "ar", "as", "at"],
      ["ae", "af", "ag", "ah", "ai", "aj", "ak", "al", "am", "an", "ao", "ap", "aq", "ar", "as", "at"],
      ["al", "am", "an", "ao", "ap", "aq", "ar", "as", "at", "au", "av", "aw", "ay", "az", "ba", "bc", "bd", "bg", "bh"],
      ["al", "am", "an", "ao", "ap", "aq", "ar", "as", "at", "au", "av", "aw", "ay", "az", "ba", "bc", "bd", "bg", "bh"]
    ],
    momForParents: [
      ["ae", "af", "ag", "ah", "ai", "aj", "ak", "al", "am", "an", "ao", "ap", "aq", "ar", "as", "at"],
      ["al", "am", "an", "ao", "ap", "aq", "ar", "as", "at", "au", "av", "aw", "ay", "az", "ba", "bc", "bd", "bg", "bh"],
      ["au", "av", "aw", "ay", "az", "ba", "bc", "bd", "bg", "bh"]
    ],
  },
  son: {
    dadForParent: [
      ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q"],
      ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q"],
      ["i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "v", "w", "y", "z", "ac", "ad"],
      ["i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "v", "w", "y", "z", "ac", "ad"]
    ],
    dadForParents: [
      ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q"],
      ["i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "v", "w", "y", "z", "ac", "ad"],
      ["r", "s", "t", "v", "w", "y", "z", "ac", "ad"]
    ],
    momForParent: [
      ["ae", "af", "ag", "ah", "ai", "aj", "ak", "al", "am", "an", "ao", "ap", "aq", "ar", "as", "at", "au"],
      ["ae", "af", "ag", "ah", "ai", "aj", "ak", "al", "am", "an", "ao", "ap", "aq", "ar", "as", "at", "au"],
      ["am", "an", "ao", "ap", "aq", "ar", "as", "at", "au", "av", "aw", "ax", "az", "ba", "bc", "bd", "bg", "bh"],
      ["am", "an", "ao", "ap", "aq", "ar", "as", "at", "au", "av", "aw", "ax", "az", "ba", "bc", "bd", "bg", "bh"]
    ],
    momForParents: [
      ["ae", "af", "ag", "ah", "ai", "aj", "ak", "al", "am", "an", "ao", "ap", "aq", "ar", "as", "at", "au"],
      ["am", "an", "ao", "ap", "aq", "ar", "as", "at", "au", "av", "aw", "ax", "az", "ba", "bc", "bd", "bg", "bh"],
      ["av", "aw", "ax", "az", "ba", "bc", "bd", "bg", "bh"]
    ],
  },
};

function customAlphabetSort(a, b) { // aからzの後にaa,ab...az,ba,bbと並び替える
  // aとbの長さが違う場合、短い方を先にする
  if (a.length !== b.length) {
    return a.length - b.length;
  }
  // 同じ長さの場合、通常の辞書順で比較する
  return a.localeCompare(b);
}

class StorySelection extends React.Component {
  constructor() {
    super();
    this.state = {
      book: Book.create({})
    };
  }

  getAddList(list, receiver, book) { // 過去に選択した内容に応じて出し分けが必要な場合、処理を行っている
    // console.log({receiver});
    // 人生を変えた言葉があり、言葉が入力されているか
    //作者
    const artistName = book.artistName;
    // 父
    const hasLifeChangingWordsFromDad = book.childToParent.hasLifeChangingWordsFromDad !== "0" && book.childToParent.lifeChangingWordsFromDad !== "";
    // 母
    const hasLifeChangingWordsFromMom = book.childToParent.hasLifeChangingWordsFromMom !== "0" && book.childToParent.lifeChangingWordsFromMom !== "";

    // 兄弟がいるか
    const hasSibling = book.childToParent.sibling !== 0;
    // 子どもがいるか
    const hasChildren = book.childToParent.children !== 0;

    // 人生を変えた言葉のエピソード

    /* const addLifeChangingWordsStory = receiver === 'dad' && hasLifeChangingWordsFromDad
      ? ["t"]
      : receiver === 'mom' && hasLifeChangingWordsFromMom
        ? ["ax"]
        : []; */
    const addLifeChangingWordsStory = artistName === 'aoyama'
      ? receiver === 'dad' && hasLifeChangingWordsFromDad
        ? ["t"]
        : receiver === 'mom' && hasLifeChangingWordsFromMom
          ? ["ax"]
          : []
      : receiver === 'dad' && hasLifeChangingWordsFromDad
        ? ["u"]
        : receiver === 'mom' && hasLifeChangingWordsFromMom
          ? ["ay"]
          : [];
    // 兄弟が一人以上いるエピソード
    const addHasSiblingStory = receiver === 'dad' && hasSibling
      ? ["x"]
      : receiver === 'mom' && hasSibling
        ? ["bb"]
        : [];
    // 子どもが一人以上いるエピソード
    const addHasChildrenStory = receiver === 'dad' && hasChildren
      ? ["aa", "ab"]
      : receiver === 'mom' && hasChildren
        ? ["be", "bf"]
        : [];
    const result = list.concat(
      addLifeChangingWordsStory,
      addHasSiblingStory,
      addHasChildrenStory
    );
    const sortList = result.sort(customAlphabetSort);
    // console.log(sortList);
    return sortList;
    // dadForParent 3・4 dadForParents 2・3
    // hasLifeChangingWordsFromDad !== "0" "t" を追加
    // sibling !== 0 なら "x" を追加
    // children !== 0 なら "aa" と "ab" を追加

    // momForParent 3・4 momForParents 2・3
    // hasLifeChangingWordsFromMom !== "0" "ax" を追加
    // sibling !== 0 なら "bb" を追加
    // children !== 0 なら "be" と "bf" を追加
  }

  onStoryOrderRadioChange = e => {
    console.log('onStoryOrderRadioChange');
    key += 3;
    // 今までの選択したストーリーをリセット
    this.props.book.childToParent.resetStories();
    this.props.book.childToParent.changeStoryOrder(e.target.value);
  }

  save = () => {
    this.props.order.saveStories();
  }

  render() {
    const { artistName, book, order, setpImage } = this.props;
    // const emptyLength = this.props.book.childToParent.receiver === '' ? 0 : 2;
    // console.log('receiver', book.childToParent.receiver);
    const list = artistName === "aoyama" ? lists.daughter : lists.son;

    return (
      <div className="story-selection pd-15">
        <img
          style={{
            padding: "16px 0px 38px",
            width: "100%",
            height: "auto"
          }}
          src={require(`../../imgs/${setpImage}`)}
        />
        {book.childToParent.receiver === 'dad' ? (
          <div className="step">
            <span className="step-txt block">{"伝えたい「ありがとう」を４つ選んでください。"}</span>
            <Storylist
              artistName={artistName}
              book={book}
              disabled={book.childToParent.stories.map(v => v)}
              list={list.dadForParent[0]}
              onSelect={selected => book.childToParent.setStory(0, selected)}
              selected={book.childToParent.stories[0]}
              storyNumber={1}
            />
            <Storylist
              artistName={artistName}
              book={book}
              disabled={book.childToParent.stories.map(v => v)}
              list={list.dadForParent[1]}
              onSelect={selected => book.childToParent.setStory(1, selected)}
              selected={book.childToParent.stories[1]}
              storyNumber={2}
            />
            <Storylist
              artistName={artistName}
              book={book}
              disabled={book.childToParent.stories.map(v => v)}
              list={this.getAddList(list.dadForParent[2], 'dad', book)}
              onSelect={selected => book.childToParent.setStory(2, selected)}
              selected={book.childToParent.stories[2]}
              storyNumber={3}
            />
            <Storylist
              artistName={artistName}
              book={book}
              disabled={book.childToParent.stories.map(v => v)}
              list={this.getAddList(list.dadForParent[3], 'dad', book)}
              onSelect={selected => book.childToParent.setStory(3, selected)}
              selected={book.childToParent.stories[3]}
              storyNumber={4}
            />
          </div>
        ) : null}
        {book.childToParent.receiver === 'mom' ? (
          <div className="step">
            <span className="step-txt block">{"伝えたい「ありがとう」を４つ選んでください。"}</span>
            <Storylist
              artistName={artistName}
              book={book}
              disabled={book.childToParent.stories.map(v => v)}
              list={list.momForParent[0]}
              onSelect={selected => book.childToParent.setStory(0, selected)}
              selected={book.childToParent.stories[0]}
              storyNumber={1}
            />
            <Storylist
              artistName={artistName}
              book={book}
              disabled={book.childToParent.stories.map(v => v)}
              list={list.momForParent[1]}
              onSelect={selected => book.childToParent.setStory(1, selected)}
              selected={book.childToParent.stories[1]}
              storyNumber={2}
            />
            <Storylist
              artistName={artistName}
              book={book}
              disabled={book.childToParent.stories.map(v => v)}
              list={this.getAddList(list.momForParent[2], 'mom', book)}
              onSelect={selected => book.childToParent.setStory(2, selected)}
              selected={book.childToParent.stories[2]}
              storyNumber={3}
            />
            <Storylist
              artistName={artistName}
              book={book}
              disabled={book.childToParent.stories.map(v => v)}
              list={this.getAddList(list.momForParent[3], 'mom', book)}
              onSelect={selected => book.childToParent.setStory(3, selected)}
              selected={book.childToParent.stories[3]}
              storyNumber={4}
            />
          </div>
        ) : null}
        {book.childToParent.receiver === '' ? ( // 両親の時
          <div>
            <Row>
              <div style={{ padding: "0 0 16px" }}>
                {"まず始めに、ストーリーの流れを決めましょう。"}
              </div>
              <div style={{ padding: "0 0 32px" }}>
                <RadioGroup
                  defaultValue="0"
                  onChange={this.onStoryOrderRadioChange}
                  value={book.childToParent.storyOrder}
                >
                  <Radio style={radioStyle} value="0" size="large">
                    父へのメッセージ → 母へのメッセージ
                  </Radio>
                  <Radio style={radioStyle} value="1" size="large">
                    母へのメッセージ → 父へのメッセージ
                  </Radio>
                </RadioGroup>
              </div>
            </Row>

            {book.childToParent.storyOrder === "0" ? (
              <div key={key}>
                <div className="step">
                  <span className="step-title-alt">{"STEP 1 "}</span>
                  <span className="step-txt">{"父に伝えたい「ありがとう」を３つ選んでください。"}</span>
                  <Storylist
                    artistName={artistName}
                    book={book}
                    disabled={book.childToParent.stories.map(v => v)}
                    list={list.dadForParents[0]}
                    onSelect={selected => book.childToParent.setStory(0, selected)}
                    selected={book.childToParent.stories[0]}
                    storyNumber={1}
                  />
                  <Storylist
                    artistName={artistName}
                    book={book}
                    disabled={book.childToParent.stories.map(v => v)}
                    list={this.getAddList(list.dadForParents[1], 'dad', book)}
                    onSelect={selected => book.childToParent.setStory(1, selected)}
                    selected={book.childToParent.stories[1]}
                    storyNumber={2}
                  />
                  <Storylist
                    artistName={artistName}
                    book={book}
                    disabled={book.childToParent.stories.map(v => v)}
                    list={this.getAddList(list.dadForParents[2], 'dad', book)}
                    onSelect={selected => book.childToParent.setStory(2, selected)}
                    selected={book.childToParent.stories[2]}
                    storyNumber={3}
                  />
                </div>
                <div className="step step2">
                  <span className="step-title-alt">{"STEP 2 "}</span>
                  <span className="step-txt">{"母に伝えたい「ありがとう」を３つ選んでください。"}</span>
                  <Storylist
                    artistName={artistName}
                    book={book}
                    disabled={book.childToParent.stories.map(v => v)}
                    list={list.momForParents[0]}
                    onSelect={selected => book.childToParent.setStory(3, selected)}
                    selected={book.childToParent.stories[3]}
                    storyNumber={4}
                  />
                  <Storylist
                    artistName={artistName}
                    book={book}
                    disabled={book.childToParent.stories.map(v => v)}
                    list={this.getAddList(list.momForParents[1], 'mom', book)}
                    onSelect={selected => book.childToParent.setStory(4, selected)}
                    selected={book.childToParent.stories[4]}
                    storyNumber={5}
                  />
                  <Storylist
                    artistName={artistName}
                    book={book}
                    disabled={book.childToParent.stories.map(v => v)}
                    list={this.getAddList(list.momForParents[2], 'mom', book)}
                    onSelect={selected => book.childToParent.setStory(5, selected)}
                    selected={book.childToParent.stories[5]}
                    storyNumber={6}
                  />
                </div>
              </div>
            ) : (
              <div key={key + 1}>
                <div className="step">
                  <span className="step-title-alt">{"STEP 1 "}</span>
                  <span className="step-txt">{"母に伝えたい「ありがとう」を３つ選んでください。"}</span>
                  <Storylist
                    artistName={artistName}
                    book={book}
                    disabled={book.childToParent.stories.map(v => v)}
                    list={list.momForParents[0]}
                    onSelect={selected => book.childToParent.setStory(0, selected)}
                    selected={book.childToParent.stories[0]}
                    storyNumber={1}
                  />
                  <Storylist
                    artistName={artistName}
                    book={book}
                    disabled={book.childToParent.stories.map(v => v)}
                    list={this.getAddList(list.momForParents[1], 'mom', book)}
                    onSelect={selected => book.childToParent.setStory(1, selected)}
                    selected={book.childToParent.stories[1]}
                    storyNumber={2}
                  />
                  <Storylist
                    artistName={artistName}
                    book={book}
                    disabled={book.childToParent.stories.map(v => v)}
                    list={this.getAddList(list.momForParents[2], 'mom', book)}
                    onSelect={selected => book.childToParent.setStory(2, selected)}
                    selected={book.childToParent.stories[2]}
                    storyNumber={3}
                  />
                </div>
                <div className="step step2">
                  <span className="step-title-alt">{"STEP 2 "}</span>
                  <span className="step-txt">{"父に伝えたい「ありがとう」を３つ選んでください。"}</span>
                  <Storylist
                    artistName={artistName}
                    book={book}
                    disabled={book.childToParent.stories.map(v => v)}
                    list={list.dadForParents[0]}
                    onSelect={selected => book.childToParent.setStory(3, selected)}
                    selected={book.childToParent.stories[3]}
                    storyNumber={4}
                  />
                  <Storylist
                    artistName={artistName}
                    book={book}
                    disabled={book.childToParent.stories.map(v => v)}
                    list={this.getAddList(list.dadForParents[1], 'dad', book)}
                    onSelect={selected => book.childToParent.setStory(4, selected)}
                    selected={book.childToParent.stories[4]}
                    storyNumber={5}
                  />
                  <Storylist
                    artistName={artistName}
                    book={book}
                    disabled={book.childToParent.stories.map(v => v)}
                    list={this.getAddList(list.dadForParents[2], 'dad', book)}
                    onSelect={selected => book.childToParent.setStory(5, selected)}
                    selected={book.childToParent.stories[5]}
                    storyNumber={6}
                  />
                </div>
              </div>
            )}
          </div>
        ) : null}

        <div
          style={{
            "paddingTop": "16px",
          }}
          className="btn-wrap"
        >
          {/* 両親あては6つ、それぞれの親あては4つなので 空文字列の数カウントが違う */}
          <button
            disabled={book.childToParent.stories.indexOf("") !== -1}
            onClick={this.save}
            className="btn product-btn"
          >
            保存して次へ
            <img
              src="https://cdn.shopify.com/s/files/1/0012/2568/7076/files/arrow-right-purple.png?13701503969354364487"
              className="btn-arrow"
            />
          </button>
        </div>
      </div>
    );
  }
}

export default observer(StorySelection);



// WEBPACK FOOTER //
// ./src/components/steps/StorySelectionChildToParent.js